export default (value: any) =>{
    switch (String(value)){
        case "1": return "Tirocini Estivi"
        case "2": return "FSL Estiva"
        case "3": return "Colloqui CV"
        case "4": return "Tirocini Formativi"
        case "5": return "Workshop"
        case "6": return "Tirocini Inserimento/ Reinserimento"
    }
}